import React from 'react';
import { SvgIcon, Row, Col, ContentBlock, CourseImage } from 'seduo-ui';
import AvatarPartnersExample from './AvatarPartner';
const EducationProgramHorizontalCardStudying = () => (<ContentBlock className="my-courses">
        <Row className="course-row">
            <Col sm={4} lg={2} className="align-self-center pr-sm-0">
                <div className="course-row__image">
                    <a href={'#'}>
                        <CourseImage src={'https://dummyimage.com/222x150/9fa4a8/fff.png'} alt={'Default course image'} isFinished={false}/>
                    </a>
                </div>
            </Col>
            <Col sm={7} className="align-self-stretch">
                <Row className="course-row__main">
                    <Col lg={7} className="course-row__info">
                        <a href={'#'} className="course-row__info-title font-weight-medium">
                            Course Title
                        </a>
                        <div className="course-row__info-subtitle">
                            <div className="course-row__info-text">
                                <span className="mr-6">123h 45m</span>
                                <span>666 lekcí</span>
                            </div>
                        </div>
                        <div className="mt-5">
                            <AvatarPartnersExample />
                        </div>
                    </Col>
                    <Col lg={5} className="course-row__activity">
                        <div className="course-row__activity-progress mt-5 mt-lg-0">
                            <div className="mb-5 progress progress--slim">
                                <div className="progress-bar bg-warning" style={{
        width: 9 + '%',
    }} role="progressbar" aria-valuenow={9} aria-valuemin={0} aria-valuemax={100}></div>
                            </div>
                            <div className="small text-muted">9&nbsp;%&nbsp;finished</div>
                        </div>
                    </Col>
                </Row>
            </Col>
            <Col lg={3} className="d-lg-flex">
                <div className="course-row__actions">
                    <a className="btn btn-success btn-sm course-row__actions-button" href={'#'} role="button">
                        <SvgIcon kind="Play" size={10} className="course-row__actions-icon course-row__actions-icon--success"/>
                        Pokračovat
                    </a>
                    <a className="btn btn-link btn-sm text-muted ajax course-row__actions-button" href="#" role="button">
                        <SvgIcon kind="Trash" size={15} className="course-row__actions-icon course-row__actions-icon--link"/>
                        Odhlásit se
                    </a>
                </div>
            </Col>
        </Row>
    </ContentBlock>);
const Example = () => <EducationProgramHorizontalCardStudying />;
export default Example;
